import { isAnalyticsEnabled } from './config';
import { TAnalyticsEvent } from './events';

export type TAnalyticsParams = Record<string, unknown>;

const cleanParams = (params: TAnalyticsParams): TAnalyticsParams => {
  const result: TAnalyticsParams = {};
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== '') result[key] = value;
  });
  return result;
};

export const pushToDataLayer = (payload: TAnalyticsParams): void => {
  try {
    if (!isAnalyticsEnabled) return;
    const cleaned = cleanParams(payload);
    if (Object.keys(cleaned).length === 0) return;
    window.dataLayer ||= [];
    window.dataLayer.push(cleaned);
  } catch {
    // ignored
  }
};

export const trackEvent = (event: TAnalyticsEvent, params: TAnalyticsParams = {}): void => {
  pushToDataLayer({ event, ...params });
};
